import {useCallback, useEffect, useState} from 'react';
import {useNavigate} from 'react-router-dom';
import {isMobile} from 'react-device-detect';
import {PATHS} from 'routes/constants';
import {usePath} from 'hooks';
import {useTimeout} from 'hooks/useTimeout';
import {useIVStore} from '@chekin/shared';
import {useQRScanner} from './useQRScanner';
import {InvalidQRModal} from './InvalidQRModal';
import {IVQRScannerDesktopView} from './IVQRScannerDesktopView';
import {IVQRScannerMobileView} from './IVQRScannerMobileView';

function IVQRScannerView() {
  const navigate = useNavigate();
  const {getFullPath} = usePath();
  const setPropertyQRScanned = useIVStore(state => state.setPropertyQRScanned);

  const [isReady, setIsReady] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [showSuccessIcon, setShowSuccessIcon] = useState(false);

  const {start: navigateTimedOut} = useTimeout(() => {
    navigate('../', {replace: true});
  }, 1500);

  const {webcamRef, startScanning} = useQRScanner({
    onSuccess: () => {
      setPropertyQRScanned(true);
      setShowSuccessIcon(true);
      navigateTimedOut();
    },
    onError: () => {
      setIsModalOpen(true);
      startScanning();
    },
  });

  useEffect(() => {
    setIsReady(true);
  }, []);

  const handleUserMedia = useCallback(() => {
    startScanning();
  }, [startScanning]);

  const handleCloseModal = useCallback(() => {
    setIsModalOpen(false);
  }, []);

  const handleBackToStart = useCallback(() => {
    setIsModalOpen(false);
    navigate(getFullPath(PATHS.guestRegistration), {replace: true});
  }, [navigate, getFullPath]);

  if (!isReady) return null;

  const desktopViewProps = {
    webcamRef,
    showSuccessIcon,
    handleUserMedia,
  };

  const mobileViewProps = {
    webcamRef,
    showSuccessIcon,
    handleUserMedia,
    handleBack: () => navigate(-1),
  };

  return (
    <>
      {isMobile ? (
        <IVQRScannerMobileView {...mobileViewProps} />
      ) : (
        <IVQRScannerDesktopView {...desktopViewProps} />
      )}

      <InvalidQRModal
        open={isModalOpen}
        onClose={handleCloseModal}
        onBackToStart={handleBackToStart}
      />
    </>
  );
}

export {IVQRScannerView};
